import Router from 'next/router';
import { useEffect } from 'react';

import { useEditCanvasStore } from '@air/feature-edit-canvas';

import { useCanvasVersionTargetSessionStore } from '~/components/Canvas/store/useCanvasVersionTargetSessionStore';
import { getCanvasIdFromHref } from '~/utils/canvases/getCanvasIdFromHref';

/**
 * Drops the version target once a navigation stops showing its canvas (close, back to asset, side nav, browser Back).
 * A reload drops the link on its own (the store is in memory). Lives in the layout: closing can unmount the editor first.
 */
export const useClearCanvasVersionTargetOnLeave = () => {
  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      const { link, setLink } = useCanvasVersionTargetSessionStore.getState();

      if (!link || getCanvasIdFromHref(url) === link.canvasId) {
        return;
      }

      setLink(null);
      useEditCanvasStore.getState().setVersionTarget(null);
    };

    Router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      Router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, []);
};
